import React, { useState, useEffect, useRef, useContext } from "react";
import { Paper } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../../Style/AccountingSheetStyle.scss'
import axios from "axios";
import { ApiLink } from '../../../APILink/ApiLink';
import authHeader from '../../../Auth/authHeader';
import LoginUserDetailed from '../../../Auth/LoginUserDetailed';
import { deleteAlert, errorAlert, handleSuccess } from '../../../Components/Alerts';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaTable } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import { HeaderPaperComponent } from "../../../Components/HeaderPaperComponent";
import DataGridWithActions from "../../../Components/DataGridWithActions";
import { LinkAndClickButton } from "../../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import InsertRecepture from '../../../CRUD/Article/InsertArticle';
import { gridHeader } from "./MillNormativGrid";
import InsertCompoundArticle from "../../StandartProduction/CompoundArticle/InsertCompoundArticle";

function NewMillNormativ() {
    const [openDetails, setOpenDetails] = useState(false);

    const [articleProductions, setArticlProductions] = useState([]);
    const [simpleArticle, setSimpleArticle] = useState([]);

    const [articleProductionID, setArticleProductionID] = useState(0);
    const [simpeArticleID, setSimpleArticleID] = useState(0);
    const [qty, setQty] = useState(0);
    const [componentsName, setComponentName] = useState("");
    const [componentNumber, setComponentNumber] = useState(0);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showInserForm, setShowInsertForm] = useState(true);
    const [changeButton, setChangeButton] = useState(false)

    const [showError, setShowError] = useState(false);
    const [sameArticleError, setSameArticleError] = useState("");

    const [formDetailData, setFormDetailData] = useState({
        ArticleComponentsID: "",
        ArticleProductionID: "",
        ArticlesID: "",
        Qty: ""
    });

    const handleOpenForm2 = () => {
        setShowInsertForm(true);
        setShowEditForm(false); // I fsheh formën e parë
    };
    const handleOpenForm1 = () => {
        setShowInsertForm(false);
        setShowEditForm(true); // I fsheh formën e parë
    };

    const handleEnable = () => {
        setForm1IsDisabled(true);
        setForm2IsDisabled(false);
    }

    const headers = authHeader();
    const email = LoginUserDetailed();

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const [data, setData] = useState([]);

    const [form1IsDisabled, setForm1IsDisabled] = useState(false);
    const [form2IsDisabled, setForm2IsDisabled] = useState(true);

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompoundArticle', { headers });
            setArticlProductions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchSimpleArticles = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'article', { headers });
            setSimpleArticle(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillNormativi/articlesComponents', {
                headers,
                params: { componentNumber: componentNumber }
            });

            setData(response.data);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const fetchNextInvoiceNumber = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillNormativi/nextinvoiceNumber', { headers });
            setComponentNumber(response.data.NextInvoiceNr);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'MillNormativi' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Receptura u fshi me sukses");
            fetchData();
        } catch (error) {
            deleteAlert("Receptura u fshi me sukses");
        }
    };

    const openRecepturForm = (event) => {
        event.preventDefault();
        if (componentsName == "" || componentsName == null) {
            errorAlert("Ju lutem emertojeni normativin")
            return
        }
        else if (simpeArticleID == 0) {
            errorAlert("Ju lutem zgjedhni lëndën e parë, për të vazhduar")
            return
        } else {
            handleEnable();
            setChangeButton(true);
            setOpenDetails(true);
            // fetchData().then(response => {
            //     if (response.length > 0) {
            //         errorAlert("Lënda e parë ka artikuj të prodhuar të regjistruara");
            //     }
            // });
        }
    }

    const saveAndNew = () => {
        setChangeButton(false);
        setOpenDetails(false);
        setData([]);
        setComponentName("");
        fetchNextInvoiceNumber();
        setForm1IsDisabled(false);
        setForm2IsDisabled(true);

        setSimpleArticleField(null);

        setArticleProductionID(0);
        setSimpleArticleID(0);
        setQty(0);
    }

    const clearEdit = () => {
        setFormDetailData({
            ArticleComponentsID: "",
            ArticleProductionID: "",
            ArticlesID: "",
            Qty: ""
        });

        // clearLine();
        handleOpenForm2();
        setShowError(false);
        setSameArticleError("");
    };
    const handleNewSubmit = (event) => {
        event.preventDefault();

        if (!articleProductionID) {
            errorAlert("Ju lutem zgjedhni artikullin për tu prodhuar");
            return;
        }
        if (!qty) {
            errorAlert("Ju lutem plotësoni sasinë");
            return;
        }

        const stateDate = {
            ArticleProductionID: simpeArticleID,
            ArticlesID: articleProductionID,
            ComponentsName: componentsName,
            ComponentNumber: componentNumber,
            Qty: qty,
            CreatedByUser: email,
        };

        axios.post(ApiLink.API_URL + "MillNormativi", stateDate, { headers })
            .then(() => {
                handleSuccess("Produkti u shtua me sukses");
                fetchData();
                setArticleCompoundfield(null);
                setQty(0);
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                errorAlert("Ndodhi një gabim i panjohur.");
                if (error.response) {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }
                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else if (error.response && error.response.status === 400) {
                    errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                } else {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }
            });
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChangeDetail = (event) => {
        const { name, value } = event.target;
        setFormDetailData({ ...formDetailData, [name]: value });
    };

    const handleSubmitDetailLine = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'MillNormativi', formDetailData, { headers })
            .then((response) => {
                fetchData();
                handleOpenForm2();
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                // console.log(error);
                errorAlert("Deshtoi editimi i recepturës")
            });
    }


    const handleEditDetails = (item) => {
        handleOpenForm1();
        setShowError(false);
        setSameArticleError("");
        setSimpleArticleField(null);
        setQty(0);
        setFormDetailData({
            ArticleComponentsID: item.ArticleComponentsID,
            ArticleProductionID: item.ArticleProductionID,
            ArticlesID: item.ArticlesID,
            Qty: item.Qty,
        });
    };

    const [simpleArticleField, setSimpleArticleField] = useState(null);
    const handleAutocompleteChangeSimpleArticle = (event, value) => {
        if (value && value.ArticleID) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`

            setSimpleArticleID(value.ArticleID);
            setSimpleArticleField(value);
            // const exists = data.some(item => item.Barcode === value.Barcode);

            // if (exists) {
            //     setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
            //     setShowError(true);
            //     return;
            // }
            // setSameArticleError("");
            setShowError(false);
        } else {
            setSimpleArticleID(0);
            setSimpleArticleField(null);
        }
    };

    const defaultPropsSimpleArticle = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${"Lënda parë"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{"Lënda parë"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };
    //Pjesa per select input field artikull te perber
    const [articleCompound, setArticleCompoundfield] = useState(null)
    const handleAutocompleteChangearticleProduction = (event, value) => {
        if (value && value.ArticleID) {
            setArticleProductionID(value.ArticleID);
            setArticleCompoundfield(value);
        } else {
            setArticleProductionID(0);
        }
    };

    const defaultPropsArticleProduction = {
        options: articleProductions,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };
    ////////////////////////
    const handleAutocompleteChangeArticleEdit = (event, value) => {
        if (value) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`
            const exists = data.some(item => item.Barcode === value.Barcode);

            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: value.ArticleID
            }));
            // fetchArticlesSalesPrice(value.ArticleID, "edit");
        } else {
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: ""
            }));
        }
    };

    const defaultPropsArticleEdit = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        {option.ArticleName}
                    </span>
                </li>
            </>
        ),
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'ArticleID':
                    if (showError === true) {
                        nextField = document.getElementById('ArticleID');

                    }
                    else {
                        nextField = document.getElementById('Qty');
                    }
                    break;
                case 'Qty':
                    // if (qty === 0) {
                    //     errorAlert("Ju lutem plotësoni sasinë");
                    //     nextField = document.getElementById('Qty');  
                    // }
                    if (showEditForm === true && showInserForm === false && showError === false) {
                        handleSubmitDetailLine(e);
                    } else if (showInserForm === true && showEditForm === false && showError === false) {
                        handleNewSubmit(e);
                    }
                    nextField = document.getElementById('ArticleID');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    const rows = data.map((item, index) => ({
        id: ++index,
        barcode: item.Barcode,
        name: item.ArticleName,
        unit: item.UnitName,
        qty: item.Qty,
        rowInfo: item,
        deleteItemId: item.ArticleComponentsID
    }));

    useEffect(() => {
        fetchArticlesProduction();
        fetchSimpleArticles();
        fetchNextInvoiceNumber();
    }, [])

    return (
        <div className="AccountingSheet__Container" style={{ paddingTop: "50px" }}>
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <TitleElements
                icon={MdManageAccounts}
                title="Krijo Normativ të ri mulliri"
            />
            <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

            <hr></hr>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ display: "flex", }}>
                        <InsertCompoundArticle fetchData={fetchArticlesProduction} type="insert" />
                    </div>
                    <div style={{ display: "flex", }}>
                        <InsertRecepture fetchData={fetchSimpleArticles} type="insert" />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/produc/normativ"
                        />
                    </div>
                </div>
            </div > */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", }}>
                    <div>
                        <InsertCompoundArticle fetchData={fetchArticlesProduction} type="insert" />
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        <InsertRecepture fetchData={fetchSimpleArticles} type="insert" />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    {changeButton ? (
                        <>
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Ruaj & i Ri"
                                    link="#"
                                    onClick={saveAndNew}
                                />
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Ruaj & Mbyll"
                                    icon={<FaTimes />}
                                    link="/produc/normativ"
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ marginLeft: "5px" }}>
                            <LinkAndClickButton
                                text="Mbyll"
                                icon={<FaTimes />}
                                link="/produc/normativ"
                            />
                        </div>
                    )}
                    {/* <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Ndrysho"
                            // icon={<FaTrash />}
                            link="#"
                        />
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/produc/normativ"
                        />
                    </div> */}
                </div>
            </div>
            <HeaderPaperComponent />
            <Paper>
                <form className='header_paper'>
                    <Box
                        noValidate
                        autoComplete="off"
                    >
                        <div >
                            <br></br>
                            <div style={{ width: "100%" }}>
                                <div className='box3'>
                                    <TextField
                                        // className="AccountingSheet__Container__Form__TextField__5"
                                        style={{ width: "100%" }}
                                        id="ComponentsName"
                                        label="Emertimi i Normativit"
                                        variant="outlined"
                                        autoComplete="off"
                                        name='ComponentsName'
                                        value={componentsName}
                                        onChange={event => setComponentName(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={form1IsDisabled}
                                    />
                                </div>
                                <br></br>
                                <Autocomplete
                                    fullWidth
                                    {...defaultPropsSimpleArticle}
                                    id="ArticlesID"
                                    includeInputInList
                                    value={simpleArticleField}
                                    onChange={handleAutocompleteChangeSimpleArticle}
                                    isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                    renderInput={(params) => (
                                        <TextField
                                            style={{ width: "100%", alignItems: "center" }}
                                            {...params}
                                            label="Lënda e Parë"
                                            disabled={form1IsDisabled}
                                        />
                                    )}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: '250px',
                                            overflow: 'auto',
                                        },
                                    }}
                                />
                            </div>
                        </div>

                    </Box>
                </form>
                <br></br>
                <br></br>
                {
                    openDetails ?
                        <div className="SalesDetail__Container">
                            <div style={{ backgroundColor: "gainsboro " }}>
                                {showInserForm && (
                                    <form onSubmit={handleNewSubmit} className='header_paper' onKeyPress={handleKeyPress}>
                                        <Box
                                            // component="form"
                                            sx={{
                                                '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <div className='AccountingSheet__Container__Form'>
                                                <div style={{ width: "90%" }}>
                                                    {/* <Autocomplete
                                                        fullWidth
                                                        {...defaultPropsSimpleArticle}
                                                        id="ArticlesID"
                                                        includeInputInList
                                                        value={simpleArticleField}
                                                        onChange={handleAutocompleteChangeSimpleArticle}
                                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{ width: "90%" }}
                                                                {...params}
                                                                label="Përzgjedh artikullin e thjeshtë"
                                                            />
                                                        )}
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflow: 'auto',
                                                            },
                                                        }}
                                                    /> */}
                                                    <Autocomplete
                                                        fullWidth
                                                        {...defaultPropsArticleProduction}
                                                        id="ArticleID"
                                                        includeInputInList
                                                        value={articleCompound}
                                                        onChange={handleAutocompleteChangearticleProduction}
                                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{ width: "90%" }}
                                                                {...params}
                                                                label="Produkti i prodhuar"
                                                            />
                                                        )}
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflow: 'auto',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className='box3'>
                                                    <TextField
                                                        className="AccountingSheet__Container__Form__TextField__5"
                                                        id="Qty"
                                                        label="Sasia"
                                                        variant="outlined"
                                                        autoComplete="off"
                                                        name='QTY'
                                                        value={qty}
                                                        onChange={event => setQty(event.target.value)}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        disabled={form2IsDisabled}
                                                    />
                                                </div>
                                                <div className="butonat">
                                                    <button type="submit"
                                                        className="btn btn-primary float-end"
                                                        style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                                        disabled={showError}
                                                    >Shto</button>
                                                </div>
                                            </div>
                                            {showError && <span style={{ color: "red" }}>{sameArticleError}</span>}

                                        </Box>
                                    </form>
                                )}
                                {showEditForm && (
                                    <div className="SalesDetail__Container">
                                        <form onSubmit={handleSubmitDetailLine} className='header_paper' onKeyPress={handleKeyPress}>
                                            <Box
                                                // component="form"
                                                sx={{
                                                    '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                                }}
                                                noValidate
                                                autoComplete="off"
                                            >
                                                <div className='AccountingSheet__Container__Form'>
                                                    <div style={{ width: "90%" }}>
                                                        <Autocomplete
                                                            fullWidth
                                                            {...defaultPropsArticleEdit}
                                                            id="ArticlesID"
                                                            includeInputInList
                                                            onChange={handleAutocompleteChangeArticleEdit}
                                                            renderInput={(params) => (
                                                                <TextField {...params}
                                                                    style={{ width: "90%" }}
                                                                    label="Përzgjedh artikullin e thjeshtë"
                                                                // variant="filled" 
                                                                />
                                                            )}
                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                                },
                                                            }}
                                                            value={simpleArticle.find(option => option.ArticleID === formDetailData.ArticlesID) || null}
                                                        />
                                                    </div>
                                                    <div className='box3'>
                                                        <TextField
                                                            className="AccountingSheet__Container__Form__TextField__5"
                                                            type="text"
                                                            id="Qty"
                                                            name="Qty"
                                                            label="Sasia"
                                                            variant="outlined"
                                                            autoComplete="off"
                                                            value={formDetailData.Qty}
                                                            onChange={handleInputChangeDetail}
                                                        />
                                                    </div>
                                                    <div className="butonat" style={{ paddingTop: "15px" }}>
                                                        <div>
                                                            <Button type="submit" variant="success" disabled={showError} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                                <i class="bi bi-check-lg"></i>
                                                            </Button>
                                                        </div>
                                                        <div>
                                                            <Button variant="danger" onClick={clearEdit} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                                <i class="bi bi-x-lg"></i>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <div className="responsive">
                                                        <div className="responsive__butonat">
                                                            <div>
                                                                <Button type="submit" variant="success" disabled={showError} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                                    <i class="bi bi-check-lg"></i>
                                                                </Button>
                                                            </div>
                                                            <div>
                                                                <Button variant="danger" onClick={clearEdit} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                                    <i class="bi bi-x-lg"></i>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {showError && <span style={{ color: "red" }}>{sameArticleError}</span>}
                                            </Box>
                                        </form>
                                    </div>
                                )}
                                <DataGridWithActions
                                    columns={gridHeader}
                                    rows={rows}
                                    handleEdit={handleEditDetails}
                                    handleDelete={handleDelete}
                                    showPayment={false}
                                />
                            </div>
                        </div>
                        : <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                            <button className="button-15" variant="contained"
                                type="submit"
                                style={{
                                    background: "#284945",
                                    width: "95%",
                                    height: "55px",
                                    alignContent: "center",
                                    transition: "background-color 0.3s ease",
                                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                                    color: "white",
                                    border: "none"
                                }}
                                disabled={form1IsDisabled}
                                onClick={openRecepturForm}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = "#4E7B67";
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "#284945";
                                }}
                            >
                                <FaTable />  Vazhdo me regjistrimin e recepturave
                            </button>
                        </div>
                }
                <br></br>
            </Paper>
        </div>
    );
}

export default NewMillNormativ;